<template>
  <div class="new_vip">
    <div class="content">
      <div class="options">
        <div class="options_item">
          会员卡号
          <el-input v-model="keyword" class="input_box" size="small"></el-input>
        </div>
        <div class="options_item">
          <el-button type="primary" size="small">查询</el-button>
        </div>
        <div class="options_item">
          <el-button size="small" @click="showSearchBox = true"
            >高级查询</el-button
          >
        </div>
        <div class="options_item">
          <el-button size="small">导出</el-button>
        </div>
        <div class="options_item">
          <el-button size="small">打印</el-button>
        </div>
        <div class="options_item">
          <el-button size="small" @click="gotoImport()">导入</el-button>
        </div>
      </div>
      <div class="stat_box">
        <div class="stat_item" style="background: #6C85FF">
          <div class="stat_item_left">
            <div class="stat_item_line">今日新增</div>
            <div class="stat_item_line"><span>0</span> 人</div>
          </div>
          <div class="stat_item_right">
            <div class="stat_item_line">本周 <span>0</span> 人</div>
            <div class="stat_item_line">本月 <span>1</span> 人</div>
          </div>
        </div>
        <div class="stat_item" style="background: #51ADFF">
          <div class="stat_item_left">
            <div class="stat_item_line">今日生日</div>
            <div class="stat_item_line"><span>0</span> 人</div>
          </div>
          <div class="stat_item_right">
            <div class="stat_item_line">本周 <span>0</span> 人</div>
            <div class="stat_item_line">本月 <span>1</span> 人</div>
          </div>
        </div>
        <div class="stat_item" style="background: #00D1A6">
          <div class="stat_item_left">
            <div class="stat_item_line">本周未消费</div>
            <div class="stat_item_line"><span>16</span> 人</div>
          </div>
          <div class="stat_item_right">
            <div class="stat_item_line">本月 <span>14</span> 人</div>
            <div class="stat_item_line">近三月 <span>3</span> 人</div>
          </div>
        </div>
        <div class="stat_item" style="background: #72BDFF">
          <div class="stat_item_left">
            <div class="stat_item_line">今日到期</div>
            <div class="stat_item_line"><span>0</span> 人</div>
          </div>
          <div class="stat_item_right">
            <div class="stat_item_line">未来7天 <span>0</span> 人</div>
            <div class="stat_item_line">未来30天 <span>0</span> 人</div>
          </div>
        </div>
      </div>
      <div class="button_line">
        <div class="button_left">
          <el-button type="primary" size="small" @click="editItems()"
            >修改</el-button
          >
          <el-button size="small" @click="delItems()">删除</el-button>
          <el-button size="small">加油消费</el-button>
          <el-button size="small">快速消费</el-button>
          <el-button size="small" @click="editAccount(1)">会员充值</el-button>
          <el-button size="small">会员续次</el-button>
          <el-button size="small">挂失锁定</el-button>
          <el-button size="small">会员延期</el-button>
          <el-button size="small" @click="editAccount(2)">积分调整</el-button>
          <el-button size="small">修改密码</el-button>
          <el-button size="small">会员调级</el-button>
          <el-button size="small">发送短信</el-button>
          <el-button size="small">发送优惠券</el-button>
        </div>
        <div class="button_right">
          <el-popover placement="bottom" width="120" trigger="click">
            <el-checkbox
              style="margin-bottom:10px"
              v-for="(item, index) in showTableItems"
              :key="index"
              v-model="item.show"
              >{{ item.name }}</el-checkbox
            >
            <el-button
              slot="reference"
              size="small"
              icon="el-icon-s-unfold"
            ></el-button>
          </el-popover>
        </div>
      </div>
      <div class="table_content">
        <el-table
          ref="multipleTable"
          :data="tableData"
          height="100%"
          :show-summary="showSum"
          :summary-method="getSummaries"
          @sort-change="sortData"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="63"></el-table-column>
          <el-table-column
            label="卡号"
            prop="card_num"
            v-if="showTableItems[0].show"
          ></el-table-column>
          <!-- <el-table-column label="卡面号" prop="number" v-if="showTableItems[1].show"></el-table-column> -->
          <el-table-column
            label="姓名"
            prop="real_name"
            v-if="showTableItems[1].show"
          ></el-table-column>
          <el-table-column
            label="等级"
            prop="card_level"
            v-if="showTableItems[2].show"
          ></el-table-column>
          <el-table-column label="头像" v-if="showTableItems[3].show">
            <template slot-scope="scope">
              <div class="headimg">
                <img :src="scope.row.headimgurl" alt="" />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="性别"
            prop="show_sex"
            v-if="showTableItems[4].show"
          ></el-table-column>
          <el-table-column
            label="手机"
            prop="mobile"
            v-if="showTableItems[5].show"
          ></el-table-column>
          <el-table-column
            label="余额"
            prop="balance"
            v-if="showTableItems[6].show"
          ></el-table-column>
          <el-table-column
            label="积分"
            prop="point"
            v-if="showTableItems[7].show"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            label="累计消费"
            prop="total_custom"
            v-if="showTableItems[8].show"
          ></el-table-column>
          <el-table-column
            label="累计积分"
            prop="total_point"
            v-if="showTableItems[9].show"
          ></el-table-column>
          <el-table-column
            label="所属分店"
            prop="shop"
            v-if="showTableItems[10].show"
          ></el-table-column>
          <el-table-column label="车辆信息" v-if="showTableItems[11].show">
            <template slot-scope="scope">
              <el-button type="text" @click="showCarMsg(scope.row.id)"
                >查看</el-button
              >
            </template>
          </el-table-column>
          <el-table-column label="开票信息" v-if="showTableItems[12].show">
            <template slot-scope="scope">
              <el-button type="text" @click="showInvoiceMsg(scope.row.id)"
                >查看</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            label="剩余时间"
            prop="show_end_time"
            v-if="showTableItems[13].show"
          ></el-table-column>
          <!-- <el-table-column width="70px;">
            <template slot="header">
              <el-popover
                placement="bottom"
                width="120"
                trigger="click">
                <el-checkbox style="margin-bottom:10px" v-for="(item,index) in showTableItems" :key="index" v-model="item.show">{{item.name}}</el-checkbox>
                <el-button slot="reference" size="small" icon="el-icon-s-unfold"></el-button>
              </el-popover>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
      <div class="page">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="page"
          :total="total"
          :page-size="10"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      :visible.sync="showSearchBox"
      @close="showSearchBox = false"
      title="高级查询"
      width="700px"
    >
      <el-form :model="searchForm" label-width="106px">
        <el-form-item label="会员姓名" class="search_form_item">
          <el-input
            size="small"
            v-model="searchForm.name"
            class="search_input"
          ></el-input>
        </el-form-item>
        <el-form-item label="生日月份" class="search_form_item">
          <el-select
            v-model="searchForm.month"
            placeholder="请选择"
            class="search_input"
            size="small"
          >
            <el-option
              v-for="index in 12"
              :key="index"
              :label="index + '月'"
              :value="index"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开卡分店" class="search_form_item">
          <el-select
            v-model="searchForm.store_id"
            placeholder="请选择"
            class="search_input"
            size="small"
          >
            <el-option
              v-for="item in store_options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开卡操作员" class="search_form_item">
          <el-select
            v-model="searchForm.emp_id"
            placeholder="请选择"
            class="search_input"
            size="small"
          >
            <el-option
              v-for="item in emp_options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="会员等级" class="search_form_item">
          <el-select
            v-model="searchForm.level_id"
            placeholder="请选择"
            class="search_input"
            size="small"
          >
            <el-option
              v-for="item in level_options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="会员状态" class="search_form_item">
          <el-select
            v-model="searchForm.status"
            placeholder="请选择"
            class="search_input"
            size="small"
          >
            <!-- <el-option
              v-for="item in store_options"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option> -->
            <el-option>所有会员</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="会员性别" class="search_form_item">
          <el-select
            clearable
            v-model="searchForm.sex"
            placeholder="请选择"
            class="search_input"
            size="small"
          >
            <el-option :value="'1'" label="男"></el-option>
            <el-option :value="'2'" label="女"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="车牌号" class="search_form_item">
          <el-input
            size="small"
            class="search_input"
            v-model="searchForm.carNum"
          ></el-input>
        </el-form-item>
        <el-form-item label="积分数量" class="search_form_item">
          <el-input
            size="small"
            class="search_input"
            v-model="searchForm.point"
          ></el-input>
        </el-form-item>
        <el-form-item label="账户余额" class="search_form_item">
          <el-input
            size="small"
            class="search_input"
            v-model="searchForm.balance"
          ></el-input>
        </el-form-item>
        <el-form-item label="累计消费金额" class="search_form_item">
          <el-input
            size="small"
            class="search_input"
            v-model="searchForm.allPay"
          ></el-input>
        </el-form-item>
        <el-form-item label="累计充值金额" class="search_form_item">
          <el-input
            size="small"
            class="search_input"
            v-model="searchForm.allAccount"
          ></el-input>
        </el-form-item>
        <el-form-item label="开卡时间" class="search_form_item">
          <el-date-picker
            v-model="searchForm.openTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
            style="width: 214px;"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="到期时间" class="search_form_item">
          <el-date-picker
            v-model="searchForm.endTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
            style="width: 214px;"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="search_button">
        <el-button type="primary" @click="search()">查询</el-button>
        <el-button @click="showSearchBox = false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="showCarDetail"
      @close="closeCarDetail"
      title="车辆信息"
      width="600px"
    >
      <div class="car_msg_box">
        <div class="car_msg_item">车牌号：{{ carDetail.car_num }}</div>
        <div class="car_msg_item">常用油品：{{ carDetail.car_num }}</div>
        <div class="car_msg_item">汽车排量：{{ carDetail.car_num }}</div>
        <div class="car_msg_item">汽车品牌：{{ carDetail.car_num }}</div>
        <div class="car_msg_item">车系(车型)：{{ carDetail.car_num }}</div>
        <div class="car_msg_item">车辆购买时间：{{ carDetail.car_num }}</div>
        <div class="car_msg_item">保险到期时间：{{ carDetail.car_num }}</div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="showInvoiceDetail"
      @close="closeInvoiceDetail"
      title="开票信息"
      width="600px"
    >
      <div class="car_msg_box">
        <div class="car_msg_item">发票类型：{{ InvoiceDetail.type }}</div>
        <div class="car_msg_item">发票抬头：{{ InvoiceDetail.car_num }}</div>
        <div class="car_msg_item">税号：{{ InvoiceDetail.car_num }}</div>
        <div class="car_msg_item">邮箱地址：{{ InvoiceDetail.car_num }}</div>
        <div class="car_msg_item">开户银行：{{ InvoiceDetail.car_num }}</div>
        <div class="car_msg_item">银行账号：{{ InvoiceDetail.car_num }}</div>
        <div class="car_msg_item">电话号码：{{ InvoiceDetail.car_num }}</div>
      </div>
    </el-dialog>
    <UserAccount
      :showAccount="showAccount"
      :accountData="accountData"
      @close="showAccount = false"
      @refresh="getData"
      :tabs="accountTabs"
    ></UserAccount>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  vipUserList,
  vipList,
  employeeOptions,
  vipCarMsg,
  vipInvoiceMsg
} from "@/api/vip";
import { storeSelect } from "@/api/employee";
import UserAccount from "@/views/apply/vip/vipUserAccount";
export default {
  components: {
    UserAccount
  },
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      keyword: "", //会员卡号
      params: {
        //查询条件
        day: "30", //天数
        shop: "" //店铺id
      },
      store_options: [], //店铺选项
      level_options: [], //会员等级选项
      emp_options: [], //员工选项
      tableData: [], //表格数据
      multipleSelection: [], //表格选中项
      showTableItems: [
        { name: "卡号", show: true },
        { name: "姓名", show: true },
        { name: "等级", show: true },
        { name: "头像", show: true },
        { name: "性别", show: true },
        { name: "手机", show: true },
        { name: "余额", show: true },
        { name: "积分", show: true },
        { name: "累计消费", show: true },
        { name: "累计积分", show: true },
        { name: "分店", show: true },
        { name: "车辆信息", show: true },
        { name: "开票信息", show: true },
        { name: "剩余时间", show: true }
      ], //表格显示内容
      page: 1, //页码
      total: 0, //总数
      showSearchBox: false, //显示高级查询窗口
      searchForm: {}, //高级查询表单
      showAccount: false, //显示修改账户弹窗
      accountData: {}, //用户账户信息
      accountTabs: "point", //充值类型 point:积分 balance:余额
      showSum: false, //显示统计行
      showCarDetail: false, //显示车辆信息
      carDetail: {}, //车辆信息
      showInvoiceDetail: false, //显示开票信息
      InvoiceDetail: {}, //开票信息
      sort: "0" //'0':正常，'1':按积分从大到小排序
    };
  },
  mounted() {
    this.getData();
    this.init();
  },
  methods: {
    // 获取数据
    getData() {
      var data = {
        token: this.token,
        app_id: this.app_id,
        page: this.page,
        point_order: this.sort
      };
      // vipUserList(data).then(res => {
      //   console.log(res);
      //   if (res.code == 200) {
      //     this.tableData = res.data.result;
      //     this.tableData.forEach(item=>{
      //       item.show_sex = item.sex == 1? "男":item.sex == 2? "女":"未知"
      //       item.show_end_time = item.up_time == 0? "永久有效":"剩余"+item.up_time+"天"
      //     })
      //     this.total = res.data.total_num;
      //     this.showSum = true;
      //   } else {
      //     this.$message(res.msg);
      //   }
      // });
    },
    // 初始化选择项
    init() {
      var data = {
        token: this.token,
        app_id: this.app_id
      };
      storeSelect(data).then(res => {
        if (res.code == 200) {
          this.store_options = res.data;
        } else {
          // this.$message({
          //   type: "error",
          //   message: "获取门店列表失败，请刷新重试"
          // })
        }
      });
      vipList(data).then(res => {
        if (res.code == 200) {
          res.data.forEach(item => {
            this.level_options.push({ id: item.id, name: item.name });
          });
        } else {
          // this.$message({
          //   type: "error",
          //   message: "获取会员等级列表失败，请刷新重试"
          // })
        }
      });
      employeeOptions(data).then(res => {
        if (res.code == 200) {
          this.emp_options = res.data;
        } else {
          // this.$message({
          //   type: "error",
          //   message: "获取员工列表失败，请刷新重试"
          // })
        }
      });
    },
    // 高级查询
    search() {
      console.log(this.searchForm);
      this.showSearchBox = false;
    },
    // 表格多选
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(val);
    },
    // 分页
    handleCurrentChange(val) {
      console.log(val);
    },
    // 会员修改
    editItems() {
      if (this.multipleSelection.length != 1) {
        this.$message("请选择一个用户操作");
      } else {
      }
    },
    // 会员删除
    delItems(i) {
      this.$confirm("删除后无法恢复！确定删除？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          var data = {
            token: this.token,
            app_id: this.app_id,
            id: i
          };
          // delList(data).then(res => {
          //   if (res.code == 200) {
          //     this.$message({
          //       type: "success",
          //       message: "删除成功"
          //     });
          //     this.getData();
          //   } else {
          //     this.$message({
          //       type: "error",
          //       message: res.msg
          //     });
          //   }
          // });
        })
        .catch();
    },
    // 会员充值 type: 1.余额，2.积分
    editAccount(type) {
      if (this.multipleSelection.length != 1) {
        this.$message("请选择一个用户操作");
      } else {
        this.accountData = {
          uid: this.multipleSelection[0].uid,
          balance: this.multipleSelection[0].balance,
          point: this.multipleSelection[0].point
        };
        this.accountTabs = type == 1 ? "balance" : "point";
        this.showAccount = true;
      }
    },
    // 自定义统计方法
    getSummaries(param) {
      console.log(param);
      if (param.data.length) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = "总计:";
            return;
          }
          if (
            column.label == "积分" ||
            (column.label == "余额" && data.length)
          ) {
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values
                .reduce((prev, curr) => {
                  const value = Number(curr);
                  if (!isNaN(value)) {
                    return prev + curr;
                  } else {
                    return prev;
                  }
                }, 0)
                .toFixed(2);
            }
          }
        });
        return sums;
      }
    },
    // 会员导入
    gotoImport() {
      this.$router.push("/apply/newVip/13/center/import");
    },
    // 查看车辆信息
    showCarMsg(id) {
      console.log(id);
      this.showCarDetail = true;
      var data = {
        token: this.token,
        app_id: this.app_id,
        id: id
      };
      // vipCarMsg(data).then(res => {
      //   if(res.code == 200){
      //     this.carDetail = res.data
      //   }else{
      //     this.$message(res.msg)
      //   }
      // })
    },
    // 关闭车辆信息
    closeCarDetail() {
      this.showCarDetail = false;
      this.carDetail = {};
    },
    // 查看开票信息
    showInvoiceMsg(id) {
      console.log(id);
      this.showInvoiceDetail = true;
      var data = {
        token: this.token,
        app_id: this.app_id,
        id: id
      };
      // vipInvoiceMsg(data).then(res => {
      //   if(res.code == 200){
      //     this.invoiceDetail = res.data
      //   }else{
      //     this.$message(res.msg)
      //   }
      // })
    },
    // 关闭开票信息
    closeInvoiceDetail() {
      this.showInvoiceDetail = false;
      this.InvoiceDetail = {};
    },
    sortData(event) {
      //自定义排序
      console.log(event);
      if (event.order == "descending") {
        this.sort = "1";
        this.page = 1;
        this.getData();
      } else if (event.order == null) {
        this.sort = "0";
        this.page = 1;
        this.getData();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.new_vip {
  padding: 10px 15px;
  height: 100%;
  background: #f1f2f6;
  overflow: auto;
  .content {
    background: #fff;
    padding: 24px;
    height: 100%;
    display: flex;
    flex-direction: column;
    .options {
      display: flex;
      line-height: 50px;
      height: 50px;
      .options_item {
        margin-left: 12px;
      }
      .short_input {
        width: 52px;
      }
      .input_box {
        width: 180px;
      }
    }
    .stat_box {
      height: 100px;
      padding: 20px 0;
      display: flex;
      // justify-content: space-between;
      .stat_item {
        width: 263px;
        display: flex;
        height: 60px;
        border-radius: 3px;
        margin-right: 10px;
        padding: 10px;
        color: #fff;
        .stat_item_left {
          flex: 2;
          border-right: 1px solid #fff;
        }
        .stat_item_right {
          flex: 3;
        }
        .stat_item_line {
          line-height: 20px;
          text-align: center;
          span {
            font-weight: blod;
          }
        }
      }
    }
    .button_line {
      line-height: 35px;
      display: flex;
      .button_left {
        flex: 1;
      }
      .button_right {
        margin-left: 10px;
      }
    }
    .table_content {
      flex: 1;
      margin-top: 15px;
      .headimg {
        width: 36px;
        height: 36px;
        img {
          width: 36x;
          height: 36px;
          border-radius: 18px;
        }
      }
    }
    .page {
      height: 60px;
      text-align: right;
    }
  }
  .search_form_item {
    display: inline-block;
    width: 50%;
    .search_input {
      width: 214px;
    }
  }
  .search_button {
    margin-top: 15px;
    text-align: center;
  }
  .car_msg_box {
    display: flex;
    flex-wrap: wrap;
    .car_msg_item {
      width: 50%;
      line-height: 40px;
    }
  }
}
</style>
